import React, { useEffect } from 'react';
import styles from './index.module.scss';
import useOverlay from 'src/hooks/useOverlay';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import Drawer from '@navi/web-ui/lib/primitives/Drawer/Drawer';
import SuspenseLoader from 'src/components/SkeletonLoader/SuspenseLoader';
// import AgTable from '@navi/web-ui/lib/components/AgTable/AgTable';
const AgTable = React.lazy(
  () => import(/* webpackChunkName: ['table'] */ '@navi/web-ui/lib/components/AgTable/AgTable')
);
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import TableLoader from 'src/components/TableLoader/TableLoader';
import { NO_FEE_WAIVER_HISTORY } from '../../constants/EmiSchedule.constant';
import { FeeWaiverHistoryColumnDefs } from '../../constants/EmiSchedule.component';
import { useDispatch, useSelector } from 'react-redux';
import { createKey } from 'src/utils/CaseDetail.utils';
import { RootState } from 'src/store';
import { useParams } from 'react-router-dom';
import { fetchFeeWaiverHistory } from '../../actions/EmiScheduleActions';
import { addClickstreamEvent } from '../../../../service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '../../../../service/clickStream.constant';

const FeeWaiverHistory: React.FC = () => {
  const dispatch = useDispatch();
  const { loanId = '', customerId = '' } = useParams();
  const { isOpen, toggle } = useOverlay();
  const handleDrawerToggle = () => {
    toggle();
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_EMISchedule_FeeWaiverHistory);
  };
  const feeComponentAdjustments = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.feeComponentAdjustments
  );

  useEffect(() => {
    if (!feeComponentAdjustments?.data) {
      dispatch(fetchFeeWaiverHistory(loanId, customerId));
    }
  }, [feeComponentAdjustments?.data]);

  return (
    <div>
      <div>
        <Button variant="text" onClick={handleDrawerToggle}>
          Fee Waiver History
        </Button>
      </div>
      <Drawer
        open={isOpen}
        onClose={handleDrawerToggle}
        headerText="Fee waiver history"
        className={styles['feeWaiverHistoryDrawer']}
      >
        {isOpen && (
          <div className={styles['table']}>
            <SuspenseLoader
              loading={!!feeComponentAdjustments?.loading}
              fallBack={<TableLoader numberOfLines={11} />}
            >
              <AgTable
                defaultColDef={{
                  suppressMovable: true,
                  autoHeaderHeight: true,
                  wrapHeaderText: true,
                  wrapText: true
                }}
                gridOptions={{ suppressCellSelection: true }}
                sizeColumnsToFit
                className="feeWaiverHistoryTable"
                rowData={feeComponentAdjustments?.data}
                columnDefs={FeeWaiverHistoryColumnDefs}
                domLayout="autoHeight"
                noRowsOverlayComponent={() => (
                  <Typography variant="p4" className={styles.emptyListText}>
                    {NO_FEE_WAIVER_HISTORY}
                  </Typography>
                )}
              />
            </SuspenseLoader>
          </div>
        )}
      </Drawer>
    </div>
  );
};

export default FeeWaiverHistory;
